<template>
  <div id="preview" class="printTeamSingle">
    <div class="titlename">
    <img src="/brand.svg" id="brand" alt=""/>
    團體預約參觀
    </div>
    <div class="table1">
      <div>預約狀態 : {{item.status}}</div>
      <table>
        <tr>
          <td>參觀日期</td>
          <td>{{moment(item.visitDate).format('yyyy/MM/DD')}}</td>
          <td>參觀時段</td>
          <td>{{item.visitTime}}</td>
        </tr>
        <tr>
          <td>預約人</td>
          <td>{{item.orderer}}</td>
          <td>預約電話</td>
          <td>{{item.ordererTel}}</td>
        </tr>
        <tr>
          <td>旅行社</td>
          <td>{{item.agency?.name || item.agencyName}}</td>
          <td>統一編號</td>
          <td>{{item.agency?.taxID || item.agencyID}}</td>
        </tr>
        <tr>
          <td>團體名稱</td>
          <td colspan="3">{{item.groupName}}</td>
        </tr>
        <tr>
          <td>領隊</td>
          <td>{{item.leader}}</td>
          <td>領隊電話</td>
          <td>{{item.leaderTel}}</td>
        </tr>
      </table>
    </div>
    <div class="table2">
      <div class="subtitle">參觀資訊</div>
      <table>
        <tr>
          <td>總人數</td>
          <td>{{item.reserveNum}}</td>
          <td :rowspan="4" :style="{width: '90px'}">導覽需求</td>
          <td :rowspan="2">
            <div class="radioGroup" :style="{display: 'flex', flexWrap: 'wrap'}">
              <div class="radio"><div :class="[item.guideNeeds===null?'checked':'']"></div><div>待確認</div></div>
              <div class="radio"><div :class="[item.guideNeeds===false?'checked':'']"></div><div>不需要</div></div>
              <div class="radio"><div :class="[item.guideNeeds===true?'checked':'']"></div><div>需要聘<span :style="{justifyContent: 'center'}">{{item.docentCount}}</span>名</div></div>
              <div class="radio"><div></div><div>不指定導覽老師</div></div>
              <div class="radio"><div></div><div>指定<span :style="{width: '6em'}"></span></div></div>
            </div>
          </td>
        </tr>
        <tr>
          <td>一般</td>
          <td>{{item.ticketCategory?.ticket_1}}</td>
        </tr>
        <tr>
          <td>優待</td>
          <td>{{item.ticketCategory?.ticket_2}}</td>
          <td :rowspan="2">
            <div class="radioGroup" :style="{display: 'flex', flexWrap: 'wrap'}">
              <div class="radio" v-for="(gt, t) in guideTopic" :key="t">
              <div :class="[gt===item.guideRemark?'checked':'']"></div><div>{{gt}}</div></div>
            </div>
          </td>
        </tr>
        <tr>
          <td>優惠</td>
          <td>{{item.ticketCategory?.ticket_3}}</td>
        </tr>
      </table>
    </div>
    <div class="table1">
      <div class="subtitle">匯款資訊</div>
      <table>
        <tr>
          <td>匯款日期</td>
          <td>{{item.remitTime ? moment(item.remitTime).format('yyyy/MM/DD') : ''}}</td>
          <td>匯款時間</td>
          <td>{{item.remitTime ? moment(item.remitTime).format('HH:mm') : ''}}</td>
        </tr>
        <tr>
          <td >後五碼</td>
          <td>{{item.remit5code || item.remitName}}</td>
          <td>匯款金額</td>
          <td>{{item.remitAmount ? '$ ' : '' }} {{item.remitAmount}}</td>
        </tr>
      </table>
    </div>
    <div class="table1">
      <div class="subtitle">備註</div>
      <div class="remark">{{item.remark}}</div>
    </div>
    <div class="footer">
      <div>接團時間: {{moment(item.createTime).format('YYYY/MM/DD HH:mm')}}</div>
      <div>業務經辦 : <span v-if="item.salesman">{{item.salesman.name}}</span><span v-else class="space"></span></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['item', 'guideTopic']
}
</script>

<style scoped>
.radioGroup {
  padding: .5em 0 .5em 1em;
  display: flex;
  flex-wrap: wrap;
  gap: 10px 7px;
}
.radio {
  display: flex;
  align-items: center;
  gap: 3px;
}
.radio span {
  display: inline-flex;
  width: 3em;
  border-bottom: 1px solid #5E5E5E;
  margin-inline: .5em;
  height: 1.5em;
}
.radio>div:nth-child(2) {
  display: flex;
  align-items: center;
}
.radio>div:nth-child(1) {
  width: 18px;
  height: 18px;
  border-radius: 10px;
  border: 1px solid #5E5E5E;
  display: flex;
  align-items: center;
  justify-content: center;
}
.radio>div:nth-child(1).checked::before {
  content: '✔';
  margin-bottom: 5px;
  margin-left: 2px;
}
.space {
  display: inline-flex;
  min-width: 6em;
}
.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.remark {
  flex: 1;
  border: 1px solid #5E5E5E;
  min-height: 180px;
  padding: .7em 1em;

}
.subtitle {
color: #5E5E5E;
font-family: Noto Sans TC;
font-size: 20px;
font-style: normal;
font-weight: 500;
line-height: normal;
letter-spacing: 1.5px;

}
.table2 tr:nth-child(1)>td:nth-child(1),
.table2 tr:nth-child(1)>td:nth-child(2) {
  background: #DADADA;
  color: #5E5E5E;
  font-family: Noto Sans TC;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 1.5px;
}
.table2 td:nth-child(1), .table2 td:nth-child(2) {
  width: 150px;
  text-align: center;
}
.table2 tr:nth-child(1) > td:nth-child(3) {
  text-align: center;
}
.table2 tr:nth-child(odd) td:last-child {
  text-align: start;
}
.table2 td {
  height: 45px;
}
.table2 tr:not(:last-child) td {
  border-bottom: 1px solid #5E5E5E;
}
.table2 td:not(:last-child), .table2 td:nth-child(2):last-child {
  border-right: 1px solid #5E5E5E;
}
.table2 {
  text-align: start;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.table1 {
  text-align: start;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.table1 table, .table2 table {
  border: 1px solid #5E5E5E;
  width: 100%;
  border-collapse: collapse;
}
.table1 tr:not(:last-child) td {
  border-bottom: 1px solid #5E5E5E;
}
.table1 td:not(:last-child) {
  border-right: 1px solid #5E5E5E;
}
.table1 td:nth-child(odd) {
  width: 150px;
  text-align: center;
  height: 45px;
}
.table1 td:nth-child(even) {
  padding-left: 13px;
  text-align: start;
  height: 35px;
  width: calc(50% - 150px);
}
.table1 td {
  color: #5E5E5E;
  font-family: Noto Sans TC;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 1.2px;
}
#preview {
  display: flex;
  flex-direction: column;
  gap: 21px;
  position: fixed;
  top: -60px;
  left: 100%;
  /* left: -700px; */
  background-color: #FFFFFF;
  width: 210mm;
  height: 297mm;
  transform: scale(.85);
  z-index: 100;
  padding: 30px 50px;
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
}
.titlename {
  color: #5E5E5E;
  font-family: Noto Sans TC;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 4px;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.titlename>img{
  width: 78px;
  height: 55px;
}
</style>
